/* eslint-disable no-plusplus */
// eslint-disable-next-line import/no-extraneous-dependencies
import 'firebase/compat/messaging';

// eslint-disable-next-line import/no-extraneous-dependencies
import firebase from 'firebase/compat/app';
// Initialize the Firebase app in the service worker by passing the generated config
const firebaseConfig = {
  apiKey: 'AIzaSyBSP1nwYVvshWBrhTttK-pMzMjozjROcrA',
  authDomain: 'klynex-dd25a.firebaseapp.com',
  projectId: 'klynex-dd25a',
  storageBucket: 'klynex-dd25a.appspot.com',
  messagingSenderId: '598281278341',
  appId: '1:598281278341:web:fd2058cc9a2eac90ae6aec',
  measurementId: 'G-9D487ZX3CX',
};
firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging();

const { REACT_APP_VAPID_KEY } = process.env;
const publicKey = REACT_APP_VAPID_KEY;

export const getToken = async (
  setTokenFound?: (found: boolean) => void
): Promise<string> => {
  let currentToken = '';

  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      currentToken = await messaging.getToken({ vapidKey: publicKey });
      if (currentToken && setTokenFound) {
        setTokenFound(true);
      } else if (setTokenFound) {
        setTokenFound(false);
      }
    } else if (setTokenFound) {
      setTokenFound(false);
    }
  } catch (error) {
    console.log('FCM Token Error - ', error);
  }

  return currentToken;
};

// export const onMessageListener = (callback: (payload: any) => void): void => {
//   messaging.onMessage((payload) => {
//     let notificationCount = 0;
//     // eslint-disable-next-line no-plusplus
//     notificationCount++;
//     // update the document title to show notification count
//     document.title = `(${notificationCount}) Your App Name`;
//     callback(payload);
//   });
// };
export const onMessageListener = () =>
  new Promise((resolve, reject) => {
    // let notificationCount = 0;

    messaging.onMessage((payload) => {
      // notificationCount++;
      // document.title = `(${notificationCount}) Klynex`;
      resolve(payload);
    });
  });
